// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"9fd6e81a","123":"64e74851","150":"480899a3","210":"3d07d8d1","263":"00186fa9","488":"bab1e1b1","532":"15c9b24c","658":"44e6dfd4","871":"b06b4a5f"}[chunkId] + ".chunk.js";
};